import { render, staticRenderFns } from "./TestPrev.vue?vue&type=template&id=11532274&scoped=true&"
import script from "./TestPrev.vue?vue&type=script&lang=js&"
export * from "./TestPrev.vue?vue&type=script&lang=js&"
import style0 from "./TestPrev.vue?vue&type=style&index=0&id=11532274&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11532274",
  null
  
)

export default component.exports